import React from 'react'
import Button from 'components/Button'
import Text from 'components/Text'

/**
 * @param onClick
 * @param text
 * @param children
 * @param icon
 * @param style
 * @param rest
 * @returns {Element}
 * @constructor
 */
export default function ChipButton ({
  onClick,
  text,
  children,
  icon,
  style,
  ...rest
}) {
  return (
    <Button
      onClick={onClick}
      style={{
        height: 'unset',
        maxWidth: 'unset',
        background: '#E6E6E6',
        borderRadius: '25px',
        padding: '10px 23px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(style || {})
      }}
      {...rest}
    >
      {icon}

      {
        children || (
          <Text
            fw='560'
            c='#000000'
          >
            {text}
          </Text>
        )
      }
    </Button>
  )
}
